import axios from "../../../config/axiosConfig";

export const getCatalogosSolicitud = () => axios.get("/api/solicitud-cheque/catalogos");
export const buscarClientesSolicitud = (q) => axios.get("/api/solicitud-cheque/clientes", { params: { q } });
export const buscarProveedoresFactura = (q) => axios.get("/api/solicitud-cheque/proveedores", { params: { q } });
export const buscarOrdenesCompra =(q) => axios.get("/api/solicitud-cheque/ordenes-compra", { params: { q } });
export const listarPlanillas = () => axios.get("/api/solicitud-cheque/planillas");
export const crearPlanilla = (body) => axios.post("/api/solicitud-cheque/planillas", body);
export const actualizarPlanilla = (id, body) => axios.put(`/api/solicitud-cheque/planillas/${id}`, body);
export const eliminarPlanilla = (id) => axios.delete(`/api/solicitud-cheque/planillas/${id}`);
export const enviarMasiva = (items) => axios.post("/api/solicitud-cheque/masiva", { items });
export const getResumenSolicitudes = () => axios.get("/api/solicitud-cheque/resumen");
export const listarSolicitudes = (params) => axios.get("/api/solicitud-cheque", { params });
export const getSolicitud = (id) => axios.get(`/api/solicitud-cheque/${id}`);
export const crearSolicitud = (body) => axios.post("/api/solicitud-cheque", body);
export const agregarFacturasSolicitud = (id, facturas) => axios.post(`/api/solicitud-cheque/${id}/facturas`, { facturas });
export const borrarFacturaSolicitud = (id, idFactura) => axios.delete(`/api/solicitud-cheque/${id}/facturas/${idFactura}`);
export const subirArchivosSolicitud = (id, archivos) => {
  const fd = new FormData();
  archivos.forEach((f) => fd.append("archivos", f));
  return axios.post(`/api/solicitud-cheque/${id}/archivos`, fd);
};

export const mensajeError = (e, defecto) => e?.response?.data?.message || e?.response?.data?.error || e?.message || defecto;

export const fmtMonto = (n) => (Number(n) || 0).toLocaleString("es-BO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const ESTADOS = {
  espera: { texto: "En espera", color: "warning" },
  autorizado: { texto: "Autorizado", color: "info" },
  emitido: { texto: "Emitido", color: "success" },
};
